import reviewCard from "./reviewCard"
export default reviewCard;
